export default __webpack_public_path__ + "static/media/ed3.697f4726.png";